const backdropTheme = {
  wrapper:
    "transition-all duration-300 ease-in-out fixed top-0 left-0 z-[1040] bg-black w-screen h-screen",
};

export default backdropTheme;
